import * as products from 'app/mocks/data/catalogue/products/list'
import * as managers from 'app/mocks/data/park/managers/list'
import * as sites from 'app/mocks/data/park/sites/list'
import * as konvives from 'app/mocks/data/users/konvives/list'

import { newDateFormatted } from 'app/utils/date'

import { Order, StatusOrder } from 'app/types/operations/order'

export const order801: Order = {
    id: 801,
    status: StatusOrder.enum.REMOVED,
    konvive: konvives.konvive1,
    site: sites.site1,
    price: 8,
    articles: [
        {
            product: products.product1,
            is_weight_quantity: true,
            quantity: 100,
        },
        {
            product: products.product2,
            is_weight_quantity: true,
            quantity: 500,
        },
        {
            product: products.product3,
            is_weight_quantity: false,
            quantity: 2,
        },
        {
            product: products.product4,
            is_weight_quantity: false,
            quantity: 3,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-20)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive1,
            changes: [
                {
                    product: products.product1,
                    is_weight_quantity: true,
                    quantity: 100,
                },
                {
                    product: products.product2,
                    is_weight_quantity: true,
                    quantity: 500,
                },
                {
                    product: products.product3,
                    is_weight_quantity: false,
                    quantity: 2,
                },
                {
                    product: products.product4,
                    is_weight_quantity: false,
                    quantity: 3,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-20)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager8,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-20)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager8,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-20)}T11:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: managers.manager8,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-1)}T12:00:00`,
            status: StatusOrder.enum.REMOVED,
            author: managers.manager8,
            changes: [],
        },
    ],
}

export const order802: Order = {
    id: 802,
    status: StatusOrder.enum.REMOVED,
    konvive: konvives.konvive2,
    site: sites.site1,
    price: 8,
    articles: [
        {
            product: products.product1,
            is_weight_quantity: false,
            quantity: 1,
        },
        {
            product: products.product2,
            is_weight_quantity: false,
            quantity: 1,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-19)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive2,
            changes: [
                {
                    product: products.product1,
                    is_weight_quantity: false,
                    quantity: 1,
                },
                {
                    product: products.product2,
                    is_weight_quantity: false,
                    quantity: 1,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-19)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager3,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-19)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager3,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-19)}T12:00:00`,
            status: StatusOrder.enum.REMOVED,
            author: managers.manager3,
            changes: [],
        },
    ],
}

export const order803: Order = {
    id: 803,
    status: StatusOrder.enum.REMOVED,
    phone_number: '0611223344',
    site: sites.site2,
    price: 8,
    articles: [
        {
            product: products.product3,
            is_weight_quantity: false,
            quantity: 3,
        },
        {
            product: products.product4,
            is_weight_quantity: false,
            quantity: 2,
        },
        {
            product: products.product5,
            is_weight_quantity: true,
            quantity: 450,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-18)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0611223344',
            changes: [
                {
                    product: products.product3,
                    is_weight_quantity: false,
                    quantity: 325,
                },
                {
                    product: products.product4,
                    is_weight_quantity: false,
                    quantity: 2,
                },
                {
                    product: products.product5,
                    is_weight_quantity: true,
                    quantity: 450,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-18)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager3,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-18)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager3,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-18)}T11:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: managers.manager3,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-18)}T12:00:00`,
            status: StatusOrder.enum.REMOVED,
            author: managers.manager3,
            changes: [],
        },
    ],
}

export const order804: Order = {
    id: 804,
    status: StatusOrder.enum.REMOVED,
    konvive: konvives.konvive3,
    site: sites.site3,
    price: 8,
    articles: [
        {
            product: products.product6,
            is_weight_quantity: false,
            quantity: 3,
        },
        {
            product: products.product7,
            is_weight_quantity: false,
            quantity: 575,
        },
        {
            product: products.product8,
            is_weight_quantity: false,
            quantity: 1,
        },
        {
            product: products.product9,
            is_weight_quantity: false,
            quantity: 275,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-17)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive3,
            changes: [
                {
                    product: products.product6,
                    is_weight_quantity: false,
                    quantity: 3,
                },
                {
                    product: products.product7,
                    is_weight_quantity: false,
                    quantity: 575,
                },
                {
                    product: products.product8,
                    is_weight_quantity: false,
                    quantity: 1,
                },
                {
                    product: products.product9,
                    is_weight_quantity: false,
                    quantity: 275,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-17)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager5,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-17)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager5,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-17)}T11:00:00`,
            status: StatusOrder.enum.CANCELLED,
            author: managers.manager5,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-17)}T12:00:00`,
            status: StatusOrder.enum.REMOVED,
            author: managers.manager5,
            changes: [],
        },
    ],
}

export const order805: Order = {
    id: 805,
    status: StatusOrder.enum.REMOVED,
    phone_number: '0622334455',
    site: sites.site4,
    price: 8,
    articles: [
        {
            product: products.product10,
            is_weight_quantity: true,
            quantity: 400,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-16)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0622334455',
            changes: [
                {
                    product: products.product10,
                    is_weight_quantity: true,
                    quantity: 400,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-16)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager3,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-16)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager3,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-16)}T11:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: managers.manager3,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-16)}T12:00:00`,
            status: StatusOrder.enum.REMOVED,
            author: managers.manager3,
            changes: [],
        },
    ],
}

export const order806: Order = {
    id: 806,
    status: StatusOrder.enum.REMOVED,
    konvive: konvives.konvive4,
    site: sites.site5,
    price: 8,
    articles: [
        {
            product: products.product11,
            is_weight_quantity: false,
            quantity: 2,
        },
        {
            product: products.product12,
            is_weight_quantity: false,
            quantity: 5,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-15)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0622334455',
            changes: [
                {
                    product: products.product11,
                    is_weight_quantity: false,
                    quantity: 2,
                },
                {
                    product: products.product12,
                    is_weight_quantity: false,
                    quantity: 5,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-15)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: konvives.konvive4,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-15)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager2,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-15)}T11:00:00`,
            status: StatusOrder.enum.CANCELLED,
            author: managers.manager2,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-15)}T12:00:00`,
            status: StatusOrder.enum.REMOVED,
            author: managers.manager2,
            changes: [],
        },
    ],
}

export const order807: Order = {
    id: 807,
    status: StatusOrder.enum.REMOVED,
    phone_number: '0633445566',
    site: sites.site6,
    price: 8,
    articles: [
        {
            product: products.product13,
            is_weight_quantity: true,
            quantity: 225,
        },
        {
            product: products.product14,
            is_weight_quantity: false,
            quantity: 4,
        },
        {
            product: products.product15,
            is_weight_quantity: false,
            quantity: 35,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-14)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0633445566',
            changes: [
                {
                    product: products.product13,
                    is_weight_quantity: true,
                    quantity: 225,
                },
                {
                    product: products.product14,
                    is_weight_quantity: false,
                    quantity: 4,
                },
                {
                    product: products.product15,
                    is_weight_quantity: false,
                    quantity: 35,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-14)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: konvives.konvive4,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-14)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager2,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-14)}T11:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: managers.manager2,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-14)}T12:00:00`,
            status: StatusOrder.enum.REMOVED,
            author: managers.manager2,
            changes: [],
        },
    ],
}

export const order808: Order = {
    id: 808,
    status: StatusOrder.enum.REMOVED,
    konvive: konvives.konvive5,
    site: sites.site7,
    price: 8,
    articles: [
        {
            product: products.product16,
            is_weight_quantity: false,
            quantity: 1,
        },
        {
            product: products.product17,
            is_weight_quantity: false,
            quantity: 6,
        },
        {
            product: products.product18,
            is_weight_quantity: false,
            quantity: 2,
        },
        {
            product: products.product19,
            is_weight_quantity: true,
            quantity: 175,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-13)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive5,
            changes: [
                {
                    product: products.product16,
                    is_weight_quantity: false,
                    quantity: 1,
                },
                {
                    product: products.product17,
                    is_weight_quantity: true,
                    quantity: 600,
                },
                {
                    product: products.product18,
                    is_weight_quantity: false,
                    quantity: 2,
                },
                {
                    product: products.product19,
                    is_weight_quantity: true,
                    quantity: 175,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-13)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager1,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-13)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager1,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-13)}T11:00:00`,
            status: StatusOrder.enum.CANCELLED,
            author: managers.manager1,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-13)}T12:00:00`,
            status: StatusOrder.enum.REMOVED,
            author: managers.manager1,
            changes: [],
        },
    ],
}

export const order809: Order = {
    id: 809,
    status: StatusOrder.enum.REMOVED,
    phone_number: '0644556677',
    site: sites.site8,
    price: 8,
    articles: [
        {
            product: products.product20,
            is_weight_quantity: true,
            quantity: 475,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-12)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0644556677',
            changes: [
                {
                    product: products.product20,
                    is_weight_quantity: true,
                    quantity: 475,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-12)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager1,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-12)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager1,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-12)}T11:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: managers.manager1,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-12)}T12:00:00`,
            status: StatusOrder.enum.REMOVED,
            author: managers.manager1,
            changes: [],
        },
    ],
}

export const order810: Order = {
    id: 810,
    status: StatusOrder.enum.REMOVED,
    konvive: konvives.konvive6,
    site: sites.site9,
    price: 8,
    articles: [
        {
            product: products.product21,
            is_weight_quantity: false,
            quantity: 3,
        },
        {
            product: products.product22,
            is_weight_quantity: false,
            quantity: 4,
        },
        {
            product: products.product23,
            is_weight_quantity: false,
            quantity: 3,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-11)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive6,
            changes: [
                {
                    product: products.product21,
                    is_weight_quantity: false,
                    quantity: 3,
                },
                {
                    product: products.product22,
                    is_weight_quantity: false,
                    quantity: 4,
                },
                {
                    product: products.product23,
                    is_weight_quantity: false,
                    quantity: 3,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-11)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager7,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-11)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager7,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-11)}T11:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: managers.manager7,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-11)}T12:00:00`,
            status: StatusOrder.enum.REMOVED,
            author: managers.manager7,
            changes: [],
        },
    ],
}

export const order811: Order = {
    id: 811,
    status: StatusOrder.enum.REMOVED,
    phone_number: '0655667788',
    site: sites.site10,
    price: 8,
    articles: [
        {
            product: products.product24,
            is_weight_quantity: false,
            quantity: 35,
        },
        {
            product: products.product1,
            is_weight_quantity: false,
            quantity: 2,
        },
        {
            product: products.product2,
            is_weight_quantity: true,
            quantity: 275,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-10)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0655667788',
            changes: [
                {
                    product: products.product24,
                    is_weight_quantity: false,
                    quantity: 35,
                },
                {
                    product: products.product1,
                    is_weight_quantity: false,
                    quantity: 2,
                },
                {
                    product: products.product2,
                    is_weight_quantity: true,
                    quantity: 275,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-10)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager7,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-10)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager7,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-10)}T11:00:00`,
            status: StatusOrder.enum.CANCELLED,
            author: managers.manager7,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-10)}T12:00:00`,
            status: StatusOrder.enum.REMOVED,
            author: managers.manager7,
            changes: [],
        },
    ],
}

export const order812: Order = {
    id: 812,
    status: StatusOrder.enum.REMOVED,
    konvive: konvives.konvive7,
    site: sites.site11,
    price: 8,
    articles: [
        {
            product: products.product3,
            is_weight_quantity: false,
            quantity: 4,
        },
        {
            product: products.product4,
            is_weight_quantity: false,
            quantity: 4,
        },
        {
            product: products.product5,
            is_weight_quantity: true,
            quantity: 525,
        },
        {
            product: products.product6,
            is_weight_quantity: false,
            quantity: 1,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-9)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive7,
            changes: [
                {
                    product: products.product3,
                    is_weight_quantity: false,
                    quantity: 4,
                },
                {
                    product: products.product4,
                    is_weight_quantity: false,
                    quantity: 4,
                },
                {
                    product: products.product5,
                    is_weight_quantity: true,
                    quantity: 525,
                },
                {
                    product: products.product6,
                    is_weight_quantity: false,
                    quantity: 1,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-9)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager6,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-9)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager6,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-9)}T11:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: managers.manager6,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-9)}T12:00:00`,
            status: StatusOrder.enum.REMOVED,
            author: managers.manager6,
            changes: [],
        },
    ],
}

export const order813: Order = {
    id: 813,
    status: StatusOrder.enum.REMOVED,
    phone_number: '0666778899',
    site: sites.site12,
    price: 8,
    articles: [
        {
            product: products.product7,
            is_weight_quantity: false,
            quantity: 37,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-8)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0666778899',
            changes: [
                {
                    product: products.product7,
                    is_weight_quantity: false,
                    quantity: 37,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-8)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager6,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-8)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager6,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-8)}T11:00:00`,
            status: StatusOrder.enum.CANCELLED,
            author: managers.manager6,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-8)}T12:00:00`,
            status: StatusOrder.enum.REMOVED,
            author: managers.manager6,
            changes: [],
        },
    ],
}

export const order814: Order = {
    id: 814,
    status: StatusOrder.enum.REMOVED,
    konvive: konvives.konvive8,
    site: sites.site13,
    price: 8,
    articles: [
        {
            product: products.product8,
            is_weight_quantity: false,
            quantity: 2,
        },
        {
            product: products.product9,
            is_weight_quantity: false,
            quantity: 42,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-7)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive8,
            changes: [
                {
                    product: products.product8,
                    is_weight_quantity: false,
                    quantity: 2,
                },
                {
                    product: products.product9,
                    is_weight_quantity: false,
                    quantity: 42,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-7)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager4,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-7)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager4,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-7)}T11:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: managers.manager4,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-7)}T12:00:00`,
            status: StatusOrder.enum.REMOVED,
            author: managers.manager4,
            changes: [],
        },
    ],
}

export const order815: Order = {
    id: 815,
    status: StatusOrder.enum.REMOVED,
    phone_number: '0677889900',
    site: sites.site14,
    price: 8,
    articles: [
        {
            product: products.product10,
            is_weight_quantity: true,
            quantity: 225,
        },
        {
            product: products.product11,
            is_weight_quantity: false,
            quantity: 3,
        },
        {
            product: products.product12,
            is_weight_quantity: false,
            quantity: 5,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-6)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0677889900',
            changes: [
                {
                    product: products.product10,
                    is_weight_quantity: true,
                    quantity: 225,
                },
                {
                    product: products.product11,
                    is_weight_quantity: false,
                    quantity: 3,
                },
                {
                    product: products.product12,
                    is_weight_quantity: false,
                    quantity: 5,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-6)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager4,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-6)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager4,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-6)}T11:00:00`,
            status: StatusOrder.enum.CANCELLED,
            author: managers.manager4,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-6)}T12:00:00`,
            status: StatusOrder.enum.REMOVED,
            author: managers.manager4,
            changes: [],
        },
    ],
}

export const order816: Order = {
    id: 816,
    status: StatusOrder.enum.REMOVED,
    konvive: konvives.konvive9,
    site: sites.site15,
    price: 8,
    articles: [
        {
            product: products.product13,
            is_weight_quantity: false,
            quantity: 1,
        },
        {
            product: products.product14,
            is_weight_quantity: false,
            quantity: 4,
        },
        {
            product: products.product15,
            is_weight_quantity: false,
            quantity: 3,
        },
        {
            product: products.product16,
            is_weight_quantity: false,
            quantity: 2,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-5)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive9,
            changes: [
                {
                    product: products.product13,
                    is_weight_quantity: false,
                    quantity: 1,
                },
                {
                    product: products.product14,
                    is_weight_quantity: false,
                    quantity: 4,
                },
                {
                    product: products.product15,
                    is_weight_quantity: false,
                    quantity: 3,
                },
                {
                    product: products.product16,
                    is_weight_quantity: false,
                    quantity: 2,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-5)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager9,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-5)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager9,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-5)}T11:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: managers.manager9,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-5)}T12:00:00`,
            status: StatusOrder.enum.REMOVED,
            author: managers.manager4,
            changes: [],
        },
    ],
}

export const order817: Order = {
    id: 817,
    status: StatusOrder.enum.REMOVED,
    phone_number: '0688990011',
    site: sites.site16,
    price: 8,
    articles: [
        {
            product: products.product17,
            is_weight_quantity: false,
            quantity: 5,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-4)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0688990011',
            changes: [
                {
                    product: products.product17,
                    is_weight_quantity: false,
                    quantity: 5,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-4)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager9,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-4)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager9,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-4)}T11:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: managers.manager9,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-4)}T12:00:00`,
            status: StatusOrder.enum.REMOVED,
            author: managers.manager4,
            changes: [],
        },
    ],
}

export const order818: Order = {
    id: 818,
    status: StatusOrder.enum.REMOVED,
    konvive: konvives.konvive10,
    site: sites.site17,
    price: 8,
    articles: [
        {
            product: products.product18,
            is_weight_quantity: false,
            quantity: 3,
        },
        {
            product: products.product19,
            is_weight_quantity: false,
            quantity: 3,
        },
        {
            product: products.product20,
            is_weight_quantity: true,
            quantity: 250,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-3)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive10,
            changes: [
                {
                    product: products.product18,
                    is_weight_quantity: false,
                    quantity: 3,
                },
                {
                    product: products.product19,
                    is_weight_quantity: false,
                    quantity: 3,
                },
                {
                    product: products.product20,
                    is_weight_quantity: true,
                    quantity: 250,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-3)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager10,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-3)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager10,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-3)}T11:00:00`,
            status: StatusOrder.enum.CANCELLED,
            author: managers.manager10,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-3)}T12:00:00`,
            status: StatusOrder.enum.REMOVED,
            author: managers.manager10,
            changes: [],
        },
    ],
}

export const order819: Order = {
    id: 819,
    status: StatusOrder.enum.REMOVED,
    phone_number: '0699001122',
    site: sites.site18,
    price: 8,
    articles: [
        {
            product: products.product21,
            is_weight_quantity: false,
            quantity: 4,
        },
        {
            product: products.product22,
            is_weight_quantity: false,
            quantity: 2,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-2)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0699001122',
            changes: [
                {
                    product: products.product21,
                    is_weight_quantity: false,
                    quantity: 4,
                },
                {
                    product: products.product22,
                    is_weight_quantity: false,
                    quantity: 2,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-2)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager10,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-2)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager10,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-2)}T11:00:00`,
            status: StatusOrder.enum.EXPIRED,
            author: managers.manager10,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-2)}T12:00:00`,
            status: StatusOrder.enum.REMOVED,
            author: managers.manager10,
            changes: [],
        },
    ],
}

export const order820: Order = {
    id: 820,
    status: StatusOrder.enum.REMOVED,
    konvive: konvives.konvive1,
    site: sites.site19,
    price: 8,
    articles: [
        {
            product: products.product23,
            is_weight_quantity: false,
            quantity: 500,
        },
        {
            product: products.product24,
            is_weight_quantity: false,
            quantity: 1,
        },
        {
            product: products.product1,
            is_weight_quantity: true,
            quantity: 275,
        },
        {
            product: products.product2,
            is_weight_quantity: false,
            quantity: 3,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-1)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive1,
            changes: [
                {
                    product: products.product23,
                    is_weight_quantity: false,
                    quantity: 500,
                },
                {
                    product: products.product24,
                    is_weight_quantity: false,
                    quantity: 1,
                },
                {
                    product: products.product1,
                    is_weight_quantity: true,
                    quantity: 275,
                },
                {
                    product: products.product2,
                    is_weight_quantity: false,
                    quantity: 3,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-1)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager8,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-1)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager8,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-1)}T11:00:00`,
            status: StatusOrder.enum.CANCELLED,
            author: managers.manager8,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-1)}T12:00:00`,
            status: StatusOrder.enum.REMOVED,
            author: managers.manager8,
            changes: [],
        },
    ],
}
